import App from '@salesforce/retail-react-app/app/theme/components/project/_app'
App.baseStyle = {
    ...App.baseStyle,
    container: {
        ...App.baseStyle.container,
        minWidth: {base: '100vw', sm: 'auto'}
    },
    headerWrapper: {
        position: 'sticky',
        top: 0,
        width: '100%',
        zIndex: 3
    }
}

export default App
